"use client";

import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

interface HandwritingAnimationProps {
  onComplete?: () => void;
}

export default function HandwritingAnimation({
  onComplete,
}: HandwritingAnimationProps) {
  const svgRef = useRef<SVGSVGElement>(null);

  // ---------------------------------------------------------
  // 1. VISUALS DATA (Sorted Left-to-Right)
  // ---------------------------------------------------------
  const visualsData = [
    // 1. "T" (The)
    "M20.9,202.7c-2.5-.3-3.2-3.8-.4-4.4,1.8-.1,3.3-1.4,4.9-2.2,9.5-5.9,18.5-12.4,27.6-18.9,35.4-25.6,70.7-51.7,101.4-82.9.7-.6,1.8-.6,2.3.2.5.6.4,1.6-.2,2.2-2.5,2.5-5.2,4.9-7.9,7.1-23.2,23-48,44.3-73.9,64.2-13.3,10.1-26.3,20.7-40.5,29.7,2.5-.1,5-.3,7.4-.3-4.2,1.1-8.3,2.2-12.6,3.1-2.5,1.1-5.2,2.5-8.1,2.3Z",
    // 2. "M" (Museum)
    "M96.1,221.7c-1.3-13.4-2.4-26.9-3.5-40.4-1.1-10.4-1.2-21.2-5.2-30.8-.2,1.4.1,2.9.3,4.3-.4-1.3-2-4.5-.6-5.5,2.6-.6,5.6,8,6.5,10.1,7.3,19.9,5.3,41.7,2.6,62.2Z",
    // 3. "u"
    "M128,195c-1.5-1.3-1.2-3.3-1-5,.2-12.5-.5-24.9-1.6-37.3-1-10.6-2.8-21-3.5-31.6.3-2.4-1.7-8,1-9,1.9.2,1.2,2.9,1.8,4.3,4.7,19.2,6.6,39,7.1,58.7,3.1-12.5,12.6-36.3,26.7-18.5,4.1,5.4,6.3,11.8,9.9,17.5,2.1,4.7,6,1.4,8.1-1.4-4.8-6.9-5.5-15.9-3.2-23.7,9.5-24.1,30.2-3.3,12.8,24.3,6.6,5.9,16.1,6.5,24.4,8.2-9.2,1.2-19.9,2.6-28.2-2.9-23.7,27.3-28-44.2-39.3-11.7-3.1,5.1-6.3,35.4-15,28.3ZM181.2,165.2c2.6-5.7,5.1-12.5,2.8-18.6-.2,0-.4.2-.5.3-4.1,4.9-4.3,12.5-2.2,18.3Z",
    // 4. "e"
    "M250.2,164c-8-1.4-10.4-34.8-11.8-42.7-.7-5.6-1.4-11.2-1.7-16.8-.1-3-.9-6.6,1.1-9.2,2.9-3,7.3-.2,9,2.7,5.5,7.4,9.2,15.9,13.4,24.1,3.2,5.8,5.7,13,11.9,16.1,7.7,2.5,15.6-12,16.4-18.4.4-2,.6-4,.8-6,0-2.9-.3-6.8,3.3-7.7,6.3-1.2,7.2,8.4,9.2,12.5,3.2,8.7,4.5,17.9,7.2,26.6.7,1.9,1.6,4.2,3.1,5.5,2.2,1.6,5.1,1.3,7.6.8-3.3,2.5-8.3,3.1-11.3,0-3.5-3.4-5.6-8-7.5-12.4-2-4.5-3.8-9.1-5.5-13.7-3.6,11.3-16.8,26.8-29,16.8-4.8-4-7.7-9.7-10.5-15.1-4.3-8-8.2-16.3-13.1-23.9,1.4,14.7,3.8,29.2,6.3,43.7,1.1,4,2.9,7.9,4.1,11.9,1.2,2.2.2,5.9-2.8,5.2Z",
    // 5. "u"
    "M357.1,160.5c-4.5-3.1-8.7-6.9-11.1-11.8-13.5,16.9-31.5,2.5-25.8-15.8,1-3,4-4.4,7-3.6-1.5.3-3.5.4-4.4,1.9-2.3,4.1-.6,9.3,1.1,13.3,4.1,10.4,15.7,4.1,19-3.6-10.5-37.1,18.2-24.5,6.5,2.6.7,6.4,3.9,12.1,7.6,17.1Z",
    // 6. "m"
    "M363,163.9c-1.2-4.8,4.2-5.6,7.7-6.1,6.9-1.4,13.7-3.4,20.4-5.7-8.5-6.2-19.6-9.6-25.4-18.9-8-14.5,9.1-24.3,17.2-9-3.3-2-7-6.1-11.3-4.4-.7.4-1.1.7-1.6,1.2-6.7,13,21.9,20.2,28.2,28.3,3.7-1.6,7.5-3.2,11-5.3-2.2-7.1.9-17.8,8.6-20.2,9.9-1.5,10.8,12.2,5.9,18,3.1-.7,6-2.4,8.4-4.4-7.1-31,26.4-23.8,11,1.3,6,6.2,17.7,4.7,22.9-1.8-.9-5.4-3.8-10.6-3.5-16.1.4-4.7,6.6-6.9,9.8-3.4,3.2,4.2,4.2,9.8,4.4,14.9-1.4,5.1,2.6,5.1,5.7,2.3,5.4-4.4,3.5-7.9,5.1-13.2,4.1-6.1,11.7-1.1,10.1,5.4,3.5-6.4,2.4-21.4,11.3-22.2,12.6,1.4,10.7,23.4,23.9,23.9,14-1.6,14.7-23.1,22.9-23.6,8.8.9,4.2,17.4,6.6,23.8.5,2.3,1.3,4.7,2.1,6.9-4.5-4.5-7.1-10.4-8.9-16.4-12.5,25.3-33.9,24.1-45.1-1.5-2,8.6-5.9,31.7-18.8,22.3-4.8,6-14,9.8-20.8,4.7-9.1,8.4-25,9.8-34.1.7-3.9,3.1-8.6,5.3-13.5,5.9-2.8.3-5.9,0-8.5-1.3-1.7,1-3.4,2-5.1,2.9-3.6,1.9-7.3,3.5-11.1,5.1-7.4,8.8-20.7,7.2-31,8.9,0,0,0,0,0,0-2,.2-4-.9-4.6-3Z",
    // 7. "o" (of) - part 1
    "M623.7,116.5c9.9-1.5,19.5-9.4,26.3-16.5-7.8-3.3-17.3-3.2-24.5,1.4-4.8,2.6-11.7,15.5-1.7,15ZM655.3,92.8c4-6.4,6.8-14.8,3-22-2.9-5.7-10-12.7-16.6-13.2-3.1,8.5,8.9,27.7,13.6,35.1Z",
    // 8. "o" (of) - part 2
    "M666.4,193c-31.2-8.5-22.2-63.8-4.2-81.5-2.3-2.7-4.3-5.2-6.5-8-.2.2-.4.5-.6.7,0,0,0,0,0,0-.2,2.3-1.8,4.1-2.9,6.1.4-1.4,1.2-3,1.5-4.5-7.9,7.9-19.9,17.5-31.6,17-6-.4-10.1-5.5-9-11.4,3.3-17.7,24.7-22.5,38.4-13.2,0,0,0-.1.1-.2-7.1-10.3-18.4-27.2-17.3-40,.8-6.5,6.7-9.1,12.4-6.6,8,3,14.7,9.2,18.3,17,4.7,10.1.3,21.7-5.6,30.3,2.2,3.1,4.5,6,6.9,9,7-6.1,16.3-8.6,25.5-8.4-1.1.4-2.5.6-3.6,1-7.2,1.8-14,5.4-18.9,11,11.3,14.9,45.6,45.7,30.2,65.2-7.1,9-21.3,18.1-33.1,16.5ZM670,186.7c8-.6,15.1-5.1,21.2-10.1,3.8-3.4,7.4-7.9,6.6-13.4-2.7-18.8-20.7-33.5-32.2-47.7-5.8,7.4-9.6,16.2-11.5,25.4-3.1,14.5-3.9,43.6,15.8,45.8Z",
    // 9. "f"
    "M748.8,117.8c-5.1-1.2-4.4-9.9-6.1-14.1-1.4-7.6-4.6-27.4,5.5-29.6-6.6,2.9-3.4,14.3-2.8,19.9.9,4.3,2.1,8.5,3.4,12.7,1.9-13.7,1.8-27.8-1.3-41.3-.4-5.5-9.8-30-5.1-31.6,9-5.5,21.9,48.8,31.3,53.4-.1,0-.3,0-.4-.1,8.3.2,17.2-15.1,18.6-22.6,1.8-4.4-1.6-11.7,3.8-13.8,9.4-2.9,18.4,47.6,30.4,52.1,1.3.7,2.9.6,4.3.4-14.5,6.3-26.5-23.8-31.7-33.9-3.5,10.4-14.8,28-27.6,24-9.2-6.7-11.9-19.3-17.1-29,2.7,8.1,6.6,53.5-5.1,53.6Z",
    // 10. "i"
    "M838.1,67.8c-2.3-.7-5.9-2-6-4.7,1.7,1.7,4.7,2.4,6,4.7Z",
    // 11. "M" (Mic)
    "M838,100.6c-4.4-2.1-6-11.1-.6-12.6-2,3.6-.3,8.8.6,12.6Z",
    // 12. "c"
    "M866.1,101.8c-23.1-7-2.8-40,13.5-27.4.8.6,1,4.2.7,3.5-.8-5-7-4.5-10.4-2.5-6.7,3.1-12,13.5-5.5,19.2,7.1,5.5,16.9,4.3,25.3,4.9-7.5,2.3-15.8,4.5-23.7,2.3Z",
    // 13. "r"
    "M893.7,100.8c-.8-.2-.6-1.1.1-1.2,0,.1-.2.3-.3.4,0,0,0,.1,0,.2,7.6-2.7,8.5-13.9,6-20.6-1.5-5.3-10.1-13.6-.9-16.2,12.9,1.3,25.3,6.8,37.6,10.5-10.4.2-21.1-.1-31.6-1.6,4.8,9.9,1.8,27.2-11,28.5Z",
    // 14. "o"
    "M984.9,133.6c-4-1.3-6.2-5.5-8-9-10.2-10.4-20.9-21-27.1-34.4-13.2,12.3-45.4-1.7-28-16,4.2-2.4,9.4-1.6,13.9-1-4.8,1.4-12.2,1.7-13.6,7.5,0,0,0,0,0,0,0,.4,0,.8.2,1.2,0,0,0-.1,0-.2,0,0,0-.2,0-.3,3.5,8,20.4,7.3,24.6,0-.8-3.6-2.2-7-3.1-10.5-.8-6.3,8.2-7.9,10.2-2.1.9-.6,1.8-1.1,2.8-1.5,2.4-1.2,5-2.1,7.6-2.8-.8-3.6-1.9-7.1-3.4-10.3-1.4-3.2,2.1-6.9,5.4-5.4,7.2,3.6,14.1,8,21,12.2,7.3-1.3,18.4,2.5,21.5-6.3-.2,8.2-9.1,9-15.3,10.7,21.9,16.8,5.6,29.9-15.9,28,2,9.7,4.1,18.9,8.4,27.8.9,2.2,2.7,3.5,4.2,5.2,2.8,3.5-1.2,8.3-5.2,7.2ZM970.8,105.3c-1-4.3-1.7-8.6-2.4-12.9-.5,0-.9-.2-1.4-.3-2.2-.6-4.4-1.3-6.6-2.2,1.3,2.5,2.7,4.9,4.3,7.2,1.9,2.8,4,5.6,6.2,8.2ZM983.7,85.2c21-1.2,9.9-10.4-1-17.2-2.2.5-4.4,1-6.1,1.3-1.1.3-2.2.5-3.3.8.5,2.4.8,4.8,1.3,7.1.5,2.7.9,5.3,1.4,8,2.6.1,5.2.1,7.8,0ZM967.1,83.8c0-.6-.2-1.3-.3-1.9-.4-3.2-.8-6.5-1.3-9.7-3.3,1.2-6.9,2.4-9.4,5,0,.3,0,.7,0,1,0,.2,0,.4.1.6,3.2,2.4,7,4,10.8,5.1ZM971.7,62.8c.5-.1,1.1-.2,1.6-.3-.5-.3-.9-.5-1.4-.8-.2-.1-.4-.2-.6-.3.1.5.3.9.4,1.4Z",
    // 15. "p"
    "M1010.6,77.9c-3.7-1.8-3.6-6.9-4.6-10.3-1.2-5.9-2.4-11.9-3.4-17.9-1.5-8.3-2.8-16.6-4.1-25-1.1-5.6-1.4-11.6-3.7-16.9,0,0,0,0,0,0-2.5,9.4-2.8,19.2-2.2,28.8,0,.3.1.7,0,1-.9-3.6-1.5-7.3-2-11.1-.6-6.9-.6-14.3,1.6-21,.9-1.3,2.7-2.9,4.1-1.3,1.3,1.2,2.3,2.7,2.8,4.4,3.8,14.3,5.1,29.2,8,43.8,1.5,6.8,2.2,14,5.1,20.3,0,0,0,0,0,0,8.3-7.5,12.4-18.8,21.4-25.7,5-3.8,10.5-1.3,11,4.9.4,8.1-3.7,15.7-6.6,23.1.3-5,1.2-10.2,1.6-15.3,0-2.7.4-5.8-.9-8.2-7.4,4.6-18.9,30.4-28,26.4Z",
    // 16. "h..."
    "M1051.6,74.4c-26.9-6.4-11.7-33.7,16.5-25.7,2.4-3.4,7.9-4.2,10.4-.4,3,5,.1,11.2-2.7,15.7,8-1.7,14.2-7.6,19.2-13.7,3.3-5.9,10.4-9.3,13.4-1.1,2.5,12.1,16.3,13.5,26.1,9.5.2-8.8,10.1-21.9,18.3-24.9,14.1-1.6,7.6,16.2,1,21.5,7.6-2.1,14.9-5.8,20.9-10.9-.8-10.4,2.5-22.6,11.1-29.1,3.5-2.7,8.9-.3,8.1,4.4-2,9.9-5.5,19.9-12.4,27.5,1.3,5.7,4.2,11,7.4,15.9,1.6,2.8,8.3,8.6,2.1,10-7.1-.6-14.1-3.3-20.8-5.3,5.2,0,10.4,0,15.6.1-1.1-1.3-2.2-2.6-3.2-4-2.6-3.6-4.8-7.6-6.2-11.8-9.8,7.7-22.4,14.4-35.2,13.1-13.1,6.9-33.5,6.8-40.1-8.8-8,9.4-21.2,20.7-34.2,15.4-4.7,2.5-10.2,3.4-15.4,2.8ZM1055.3,66.7c2.6-.2,5.1-.9,7.4-2,0-4.6,1.7-9.2,3.7-13.3-6.5.9-13.5,1.6-18.9,5.6-6.1,5.3,2.2,10.7,7.8,9.7ZM1181.2,37.1c3.5-5,5.6-10.7,7.3-16.6-4.4,4.3-6.4,10.6-7.3,16.6Z",
  ];

  // ---------------------------------------------------------
  // 2. MASK DATA (Strict Left-to-Right + T REVERSED)
  // ---------------------------------------------------------
  const maskData = [
    // 1. T & S
    "M40.9 199 L18.7 202 L57 177.6 L121.5 127.5 L156.2 94.6",
    // 2. Museum M
    "M85.8,149.3l5,8.1s8.9,37.2,5.3,64.3",
    // 3. Museum u
    "M123.1,112.8s8.2,68.1,7,71.3.4,13.5,1.8,9.1,6.7-36.7,11.7-37.3,5-3.2,8.2-.6,7.6,17,12.3,20.8,4.1,7,8.8,3.8,11.4-7.5,13.5-14.8,6.5-20.5,2.1-21.6-7-2.6-9.1,0-19.4,36.4,30.2,38.4",
    // 4. Museum e
    "M250.6,164.7s-12.5-50.7-11-61.6,5.6-1.8,5.6-1.8c0,0,15.5,37.1,28.5,40.1,14.1,3.2,20-26.3,20-26.3,0,0-1.5-12.2,2.6.6s10.3,29.9,10.3,29.9c0,0,2.3,7.3,12,6.8",
    // 5. Museum u
    "M327,129.5s-5.8-.9-7.4,7.9,7.7,15.3,11,15.8,13.2-3.5,14.7-8.2,6.2-14.1,4.4-18.5-5-8.8-5-4.1,1.5,24.7,4.7,28.8,8.8,10.6,8.8,10.6",
    // 6. Museum m
    "M381.9,123.1s-7.9-6.3-11.7-4.9c0,0-10.7,11.8,5.7,20.6s20.7,9.8,19.8,15.2-14,10.7-25.2,10,4.4-4,4.4-4c0,0,27.6-6.2,34-10.6s15.6-8.8,15-14.1-4.6-10-7-7.4-6,9.5-3.9,13.9,7.9,6,13.5,4.1,10.9-4.8,13.3-9.2,4.4-16.1,1.5-15.8-6.2,2.6-5.3,8.5,3.9,14.7,8.6,16.1,21.5,2.9,24.7-6.2.2-20.9-1.3-18.6-1.3,17.1,7.5,19.6,12-2.6,13.2-5.1,1.7-13.2,4.1-12.9,1.9,16.1,4.5,15.8,5.1-6.4,6-10.5,3.3-18,6.3-18,4.3,4.9,8.1,11.6,8.8,12,13.2,12,9.6-1.9,13-5c7.4-7,10-19.7,11.7-19.4s1.9,5.1,2.8,9.8,1.8,10.2,5.6,17.1",
    // 7. of (o)
    "M652.5,109.1s4.7-4.8.9-7.4-4.4-6.2-11.2-6.2-17.9,1.2-21.1,5.2-8.5,14.1-5,15.9,6.8,6.2,15,1.8,23.2-17.3,25.5-22,10.9-15,6.7-23.5-7.3-13.5-13.5-16.7-8.5-3.5-11-.9-2.2,8.8.4,16.4,24.7,39.3,28.2,42.6,22.3,23.2,25.5,29.9,9.7,12.1,8.5,22.8-17.6,19.8-21.7,21-21.3,6.5-27.8-12c0,0-8.6-31.9,6.6-54,0,0,12.6-22.6,32.3-22.3",
    // 8. of (f)
    "M745,76s-3.2,5.4-2.6,14.8,5.4,24.6,6.5,24.1,6.1-7.3,4.9-19.6-4.6-49-9-56.3,8.1,15.5,8.1,15.5c0,0,9.1,25.2,12.9,29.4s8.2,14.7,21.1-.6,10.6-28.8,10.6-28.8l9.2,22.9s7.8,24.4,23.6,26.4",
    // 9. Mic (i)
    "M831.7 63.1 838.8 67.9",
    // 10. Mic (M)
    "M836.4,88.1s-2.9,1.9,1.2,12.7",
    // 11. Mic (c)
    "M880.4,77.3s-11.7-15-22.6,11.7c0,0-2.1,12.7,31.1,11.6",
    // 12. Mic (r-o-p-h-o-n-e-s)
    "M893.2,100.2s12.8-4.3,11-14.9-7.2-18.8-7.2-18.8l35.5,7.5s-18.4,3.5-12.2,11.3,21.2,7,25.7,3.5,4.4-6.4,5.4-8.9.4-2.4,0-3.6l-2.9-6.7s2.2,27.7,38.7,61.4c0,0-15.6-35.2-16.4-46.3s-6.4-32.9-6.4-32.9c0,0,28.6,14.7,34,25.3s-18.2,12.8-18.2,12.8c0,0-33.2-4.3-31.2-11.6s28-12.8,28-12.8l22.3-2.7s5.4.6,6.9-5.2",
    // 13. Mic (o end)
    "M992.6,36.8s-2.3-22.3.6-30.5,6.2,11.7,6.2,11.7l9.5,54.1s1.1,6.3,4.9,3.1,19.1-23.9,19.1-23.9c0,0,8.2-8.7,8.8,2.1s-4,21.1-4,21.1",
    // 14. Mic (phones end)
    "M1068,50s-13.7-.6-17.5,1.8-14.2,10-3.4,16.4,26.5-6.9,26.5-6.9c0,0,3.2-8.8,1.1-10.8s-6.9,6.3-6.9,6.3c0,0-5.6,12.3,5,12.3s29.9-20.8,29.9-20.8c0,0,4.1,13.7,12.5,15.4s14.7,3.3,21.2-1.6,18.3-10.9,19.7-14.4,2.5-11.1-1.9-10.2-12.8,10.2-14.2,15.2-.3,9.3,4.1,8.7,22-4.7,29.9-12.3,17-16.4,17.6-31.7c0,0-1.8-2.9-3.5-1.5s-11.4,15.6-11.2,20.5.9,17,5.3,21.7,10.6,11.2,8.2,11.2-19.3-1.4-19.3-1.4",
  ];

  useGSAP(
    () => {
      if (!svgRef.current) return;

      gsap.set(svgRef.current, { opacity: 1 });

      const maskPaths = gsap.utils.toArray<SVGPathElement>("#reveal-mask-group path");
      const tl = gsap.timeline({
        defaults: { ease: "none" },
        delay: 4, // 4 second delay before animation starts
        onComplete: () => {
          // Wait 1 second after animation ends before triggering fade to menu
          setTimeout(() => {
            if (onComplete) onComplete();
          }, 1000);
        },
      });

      maskPaths.forEach((path) => {
        const length = path.getTotalLength();
        const duration = length / 2000;

        gsap.set(path, {
          strokeDasharray: length,
          strokeDashoffset: length,
          opacity: 0,
        });

        // REPLACED LOGIC:
        // By using standard timeline behavior (no position parameter),
        // GSAP naturally puts each animation at the end of the previous one.
        // This guarantees NO OVERLAP.

        tl.to(path, { opacity: 1, duration: 0.01 }); // Appear
        tl.to(path, { strokeDashoffset: 0, duration: duration }); // Draw
      });

      // Store timeline ref for external control (e.g., skip functionality)
      return tl;
    },
    { scope: svgRef },
  );

  return (
    <svg
      ref={svgRef}
      viewBox="0 0 1195.8 225.9"
      className="w-full h-auto"
      style={{ opacity: 0, transform: "translateY(100px)" }}
    >
      <defs>
        <mask id="handwriting-mask">
          <rect width="100%" height="100%" fill="black" />
          <g
            id="reveal-mask-group"
            stroke="white"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="5"
          >
            {maskData.map((d, i) => (
              <path key={`mask-${i}`} d={d} />
            ))}
          </g>
        </mask>
      </defs>

      <g mask="url(#handwriting-mask)" fill="currentColor">
        {visualsData.map((d, i) => (
          <path key={`visual-${i}`} d={d} />
        ))}
      </g>
    </svg>
  );
}
